import React, {
    Fragment,
    useRef,
    useState,
} from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { RiEyeLine, RiEyeOffLine } from 'react-icons/ri';
import { MdContentCopy } from "react-icons/md";
import { IoCheckmarkSharp} from "react-icons/io5";
import { DeleteTokenModal } from '#src/components/dialogs/deleteTokenModal';
import { APIDeleteToken, APIUpdateToken } from '#src/api/token/Token.js';
import {TfiClose} from "react-icons/tfi";


export const TokenInfoModal = ({ show, setShow, getTokens, token }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const cancelButtonRef = useRef(null);
    const [name, setName] = useState(token.name);
    const [status, setStatus] = useState(token.status);
    const [showToken, setShowToken] = useState(false);
    const [copyLink2, setCopyLink2] = useState(false);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    const updateToken = async () => {
        try {
            await APIUpdateToken({
                id: token.id,
                name,
                status,
            });
            getTokens();
            setShow(false);
        } catch (error) {
            console.error('Error updating token:', error);
        }
    };

    const deleteToken = async () => {
        try {
            await APIDeleteToken(token.id);
            getTokens();
            setShow(false);
        } catch (error) {
            console.error('Error deleting token:', error);
        }
    };

    return (
        <Transition.Root show={show} as={Fragment}>
            <Dialog
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={setShow}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >

                            <Dialog.Panel className='flex max-w-2xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative' >
                                {showDeleteModal && <DeleteTokenModal
                                    show={showDeleteModal}
                                    setShow={setShowDeleteModal}
                                    token={token}
                                    deleteToken={deleteToken}
                                />}

                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => setShow(false)}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className={' flex flex-col w-full'}>
                                        <Dialog.Title
                                            as='h3'
                                            className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                                            API-Schlüssel
                                        </Dialog.Title>
                                        <div className='p-8 flex flex-col flex-1 overflow-y-auto'>
                                            <div className="w-full">
                                                <label htmlFor="email" className="text-base mb-2 block font-semibold leading-6 text-gray-900">
                                                    Name
                                                </label>
                                                <div className="mt-1">
                                                    <input
                                                        id="name"
                                                        name="name"
                                                        type="text"
                                                        value={name}
                                                        onChange={(e) => {
                                                            setName(e.target.value);
                                                        }}
                                                        className="block w-full rounded-md border-0 p-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    />
                                                </div>
                                            </div>
                                            <div className="w-full">
                                                <label htmlFor="email" className="text-base mt-6 mb-2 block font-semibold leading-6 text-gray-900">
                                                    Schlüssel
                                                </label>
                                                <div className="mt-1 flex">
                                            <pre className="text-sm rounded-md border border-gray-300 w-full relative p-4 pb-12 text-gray-600" >
                                                {showToken ? token.token : '*'.repeat(token.token.length)}
                                                <div
                                                    onClick={()=>{ setShowToken(!showToken) } }
                                                    className="p-2 ring-gray-500 right-12 bottom-2 cursor-pointer rounded-md absolute ring-1  hover:text-white hover:bg-gray-900"
                                                >
                                                    {(showToken) ? <RiEyeOffLine/> : <RiEyeLine  />}
                                                </div>
                                                <div
                                                    onClick={()=>{ copyToClipboard(token.token); setCopyLink2(true) } }
                                                    className={(copyLink2 === false)? "p-2 ring-gray-500 right-2 bottom-2 cursor-pointer rounded-md absolute ring-1  hover:text-white hover:bg-gray-900" :"p-2 ring-gray-500 right-2 bottom-2 cursor-pointer rounded-md absolute ring-1  text-white bg-gray-900"}
                                                >
                                                    {(copyLink2 === false) ? <MdContentCopy/> : <IoCheckmarkSharp  />}
                                                </div>
                                            </pre>
                                                </div>
                                            </div>
                                            <div className="w-full">
                                                <label htmlFor="status" className="text-base mt-6 mb-2 block font-semibold leading-6 text-gray-900" >
                                                    Status
                                                </label>
                                                <div className="mt-1">
                                                    <select
                                                        id="status"
                                                        name="status"
                                                        value={status}
                                                        onChange={(e) => {
                                                            setStatus(e.target.value);
                                                        }}
                                                        className="block w-full rounded-md border-0 p-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                    >
                                                        <option value="active">Aktiv</option>
                                                        <option value="inactive">Inaktiv</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="p-8 pt-0 sm:flex-row-reverse justify-between flex w-full flex-col-reverse gap-4">
                                            <button
                                                type="button"
                                                className={"text-center truncate items-center rounded-md bg-white text-gray-900  border-gray-900 border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"}
                                                onClick={updateToken}
                                            >
                                                Speichern
                                            </button>

                                            <button
                                                type="button"
                                                className={"text-center truncate items-center rounded-md bg-white text-red  border-red border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"}
                                                onClick={() => setShowDeleteModal(true)}
                                            >
                                                Löschen
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>

                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
}
